import { round } from './decimal'

/**
 * 厘米转像素
 *
 * @param cm 厘米
 * @returns px 像素
 */
export const cm2px = (cm: number) => {
  const ppi = window.devicePixelRatio * 96
  return (cm / 2.54) * ppi
}

export const unitTools = (() => {
  const div = document.createElement('div')
  div.style.width = '1cm'
  div.style.visibility = 'hidden'
  document.body.appendChild(div)
  const width = getComputedStyle(div, null).width
  const ratio = Number.parseFloat(width)
  document.body.removeChild(div)
  return {
    cm2px: (cm: number) => round(cm * ratio, { precision: 2 }),
    px2cm: (px: number) => round(px / ratio, { precision: 2 })
  }
})()
